module.exports = __webpack_public_path__ + "static/media/foretagstraning_bg.719bb8bb.jpg";